// @ts-ignore it is not error
import pollOption from './pollOption.ejs';

export default pollOption;
